export default __webpack_public_path__ + "static/media/m-fsk-10.7b660d64.jpg";